<template>
  <div
    style="
      overflow: hidden;
      display: flex;
      flex-direction: column;
      height: 100%;
    "
  >
    <ul
      style="
        border-bottom: 1px solid #e2e2e2;
        padding: 15px;
        display: flex;
        align-items: center;
      "
    >
      <li style="flex: 1">
        权限配置
        <el-checkbox label="全选" value="all" @change="onTotalChange($event)" />
      </li>
      <el-button type="primary" @click="onSubmit()">提交</el-button>
    </ul>
    <ul
      style="
        font-size: 14px;
        display: flex;
        flex-direction: column;
        flex: 1;
        overflow: hidden;
        position: relative;
        padding: 0 10px;
        margin: 10px 0;
      "
      class="role_authorize_box"
    >
      <el-checkbox-group
        v-model="state.sjqx"
        style="display: flex; flex-direction: column; flex: 1; overflow: hidden"
        :key="state.key"
      >
        <el-table
          :data="state.menus"
          row-key="id"
          default-expand-all
          :tree-props="{ children: 'menus' }"
          v-loading="!Array.isArray(state.menus)"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          :default-sort="{
            prop: state.params.sort_field,
            order:
              state.params.sort_value == 'desc' ? 'descending' : 'ascending',
          }"
          @sort-change="onSortChange"
        >
          <el-table-column prop="name" sortable="name" label="菜单名称">
            <template #default="{ row }">
              <el-checkbox
                :label="row.name"
                :value="row.id"
                :title="row.id"
                style="font-weight: 600"
                @change="onMenuChange($event, row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作权限">
            <template #default="{ row }">
              <el-checkbox
                label="全选"
                :value="'all-' + row.id"
                v-if="row.children_count > 1"
                style="font-weight: 600; color: #1e90ff"
                @change="onAllChange($event, row)"
              />
              <el-checkbox
                v-for="item in row.btns"
                :key="item"
                :label="item.name"
                :title="item.id"
                :value="item.id"
                @change="onBtnChange($event, item, row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="数据权限">
            <template #default="{ row }">
              <template v-if="row.is_data_auth">
                <el-checkbox
                  label="全部"
                  :value="'sjqx-' + row.id + '-1'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 1)"
                />
                <el-checkbox
                  label="部门及下级"
                  :value="'sjqx-' + row.id + '-2'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 2)"
                />
                <el-checkbox
                  label="仅部门"
                  :value="'sjqx-' + row.id + '-3'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 3)"
                />
                <el-checkbox
                  label="个人"
                  :value="'sjqx-' + row.id + '-4'"
                  @change="onDataAuthChange($event, 'sjqx-' + row.id + '-', 4)"
                />
              </template>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { role_detail, role_auth } from "@/http/adminrole";
import { menu_tree } from "@/http/menu";
import { ElMessage } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const state = reactive({
      data: [],
      ids: [],
      params: {},
      sjqx: [],
    });
    onMounted(() => {
      menu_tree().then((res) => {
        if (res.status == 200) {
          state.data = res.data.data.list;

          state.menus = [];
          state.data.forEach((e) => {
            e.menus = buildMenu(e.children?.filter((w) => w.type == 1));
            e.menuIds = e.menus.map((m) => m.id);
            e.btns = buildMenu(e.children?.filter((w) => w.type == 0));
            e.btnIds = e.btns.map((m) => m.id);
            state.menus.push(e);
          });
        }
      });

      role_detail(props.id).then((res) => {
        if (res.status == 200) {
          state.model = res.data.data;
          state.sjqx = [
            ...state.model.menus.split(",").map((m) => parseInt(m)),
            ...state.model.data_auth?.map((m) => {
              return "sjqx-" + m.menu + "-" + m.type;
            }),
          ];
        }
      });
    });

    //重构菜单数组
    const buildMenu = (data) => {
      const res = [];
      data?.forEach((e) => {
        if (e.children?.length > 0) {
          e.menus = buildMenu(e.children.filter((w) => w.type == 1));
          e.menuIds = e.menus.map((m) => m.id);
          e.btns = buildMenu(e.children.filter((w) => w.type == 0));
          e.btnIds = e.btns.map((m) => m.id);
        } else {
          e.menus = [];
          e.menuIds = [];
          e.btns = [];
          e.btnIds = [];
        }
        res.push(e);
      });

      return res;
    };

    const onTotalChange = (checked) => {
      state.sjqx = [];
      if (checked) {
        state.menus.forEach((fMenu) => {
          state.sjqx = [
            ...state.sjqx,
            fMenu.id,
            ...fMenu.btnIds,
            "all-" + fMenu.id,
          ];

          fMenu.children?.forEach((sMenu) => {
            state.sjqx = [
              ...state.sjqx,
              sMenu.id,
              "all-" + sMenu.id,
              ...sMenu.btnIds,
              "sjqx-" + sMenu.id + "-1",
            ];
          });
        });
      }
    };

    //菜单选择事件
    const onMenuChange = (checked, menu) => {
      if (menu.pid == 0) {
        //一级菜单
        if (checked) {
          state.sjqx = [
            ...new Set([
              ...state.sjqx,
              ...menu.menuIds,
              menu.id,
              ...menu.menuIds.map((m) => {
                return "sjqx-" + m + "-1";
              }),
            ]),
          ];
        } else {
          //获取一级菜单下的所有二级菜单Id及按钮Id
          let btnIds = [];
          menu.children?.forEach((e) => {
            btnIds = [
              ...btnIds,
              ...e.btnIds,
              "all-" + e.id,
              "sjqx-" + e.id + "-1",
              "sjqx-" + e.id + "-2",
              "sjqx-" + e.id + "-3",
              "sjqx-" + e.id + "-4",
            ];
          });
          const ids = [...menu.menuIds, ...btnIds, menu.id];
          state.sjqx = state.sjqx.filter((w) => !ids.includes(w));
        }
      } else {
        if (checked) {
          state.sjqx.push(menu.pid);
          state.sjqx.push("sjqx-" + menu.id + "-1");
        } else {
          //取消本菜单所有按钮
          state.sjqx = state.sjqx.filter(
            (w) => !menu.btnIds.includes(w) && w != "all-" + menu.id,
          );
          state.sjqx = state.sjqx.filter(
            (w) =>
              ![
                "sjqx-" + menu.id + "-1",
                "sjqx-" + menu.id + "-2",
                "sjqx-" + menu.id + "-3",
                "sjqx-" + menu.id + "-4",
              ].includes(w),
          );
        }

        const pMenu = state.menus.find((w) => w.id == menu.pid);
        if (pMenu.menuIds.some((e) => state.sjqx?.includes(e))) {
          if (state.sjqx.includes(pMenu.id)) state.sjqx.push(pMenu.id);
        } else {
          state.sjqx = state.sjqx.filter((w) => w !== pMenu.id);
        }
      }
    };

    //菜单下的全选事件
    const onAllChange = (checked, menu) => {
      if (menu.pid == 0) {
        if (checked) {
          let ids = [];
          menu.children?.forEach((m) => {
            ids.push("all-" + m.id);
            m.children?.forEach((b) => {
              ids.push(b.id);
            });
          });
          state.sjqx = [
            ...new Set([
              ...state.sjqx,
              ...ids,
              "all-" + menu.id,
              ...menu.btnIds,
            ]),
          ];
        } else {
          menu.children?.forEach((m) => {
            state.sjqx = state.sjqx.filter((w) => w != "all-" + m.id);
            state.sjqx = state.sjqx.filter((w) => !m.btnIds.includes(w));
          });
        }
      } else {
        if (checked) {
          state.sjqx = [
            ...new Set([...state.sjqx, ...menu.btnIds, "all-" + menu.id]),
          ];
        } else {
          state.sjqx = state.sjqx.filter((w) => w !== "all-" + menu.id);
          menu.btnIds?.forEach((e) => {
            state.sjqx = state.sjqx.filter((w) => w !== e);
          });
        }
      }
    };

    const onSubmit = () => {
      let data = {
        id: props.id,
        menus: state.sjqx.filter((w) => typeof w == "number").join(","),
        data_auth: state.sjqx
          .filter((w) => w.toString().includes("sjqx"))
          .map((m) => {
            const arr = m.split("-");
            return { menu: parseInt(arr[1]), type: parseInt(arr[2]) };
          }),
      };

      role_auth(data).then((res) => {
        if (res.status == 200) {
          ElMessage({
            message: res.data.msg,
            showClose: true,
            dangerouslyUseHTMLString: true,
            type: res.status ? "success" : "error",
          });
          if (res.status == 200) {
            setTimeout(() => {
              emit("close");
            }, 500);
          }
        }
      });
    };

    //数据权限改变事件
    const onDataAuthChange = (checked, prefix, type) => {
      state.sjqx = state.sjqx.filter((w) => !w.toString().includes(prefix));
      if (checked) state.sjqx.push(prefix + type);
    };

    return {
      state,
      onSubmit,
      onTotalChange,
      onAllChange,
      onMenuChange,
      onDataAuthChange,
    };
  },
};
</script>
<style lang="less">
.role_authorize_box {
  .el-checkbox-group {
    line-height: inherit;
    font-size: inherit;
  }
}
</style>
<style scoped lang="less">
th,
td {
  padding: 10px;
}
</style>
